import React from 'react';
import { useNavigate } from 'react-router';
import { useTheme, Box } from '@mui/system';
import { Stack, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { Circle, ChevronRightRounded } from '@mui/icons-material';
import AverageCostChip from './AverageCostChip';

function ActiveCardEntry(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const optimizationCount = props.draft.openOptimizationCount ?? 0;

    function handleClick() {
        sessionStorage.setItem('cardListScrollPosition', window.scrollY);
        navigate(`/physician/drafts/${props.draft.id}`, { state: {
            physician: props.physician
        }});
    }

    return (
        <Stack direction='row' justifyContent='space-between' onClick={handleClick} sx={{ backgroundColor: '#FFFFFF', borderRadius: '4px', boxShadow: 2 }} alignItems='center'>
            <Stack width='fill' max-width='70%' sx={{ alignSelf: 'stretch' }}>
                { optimizationCount > 0 &&
                    <Box role='img' aria-label={`${optimizationCount} open ${optimizationCount === 1 ? 'optimization' : 'optimizations'} to review`} sx={{ alignSelf: 'flex-start', px: 1.5, py: 0.5, borderRadius: '4px 0 4px 0', backgroundColor: `${theme.palette.blue.main}1F`, color: theme.palette.blue.main, fontSize: '11px', fontWeight: 600, lineHeight: 1.25 }}>
                        {optimizationCount} {optimizationCount === 1 ? 'rec' : 'recs'} to review
                    </Box>
                }
                <Stack spacing={0.5} p={2} pt={optimizationCount > 0 ? 1 : 2}>
                    <Stack direction='row' alignItems='center' spacing={1} sx={{ minWidth: 0 }}>
                        <Box sx={{ minWidth: 0, fontSize: '14px', color: '#000000DE', overflowWrap: 'anywhere' }}>
                            <Typography variant='normal'>{props.draft.card.name}</Typography>
                        </Box>
                    </Stack>
                    <Stack direction='row' spacing={1} alignItems='center'>
                        <Box sx={{ maxHeight: '4px', maxWidth: '4px', color: props.draft.status === 'review' ? `${theme.palette.yellow.inProgress}` : `${theme.palette.blue.main}` }}>
                            <Circle sx={{ maxHeight: '4px', maxWidth: '4px' }} />
                        </Box>
                        <Stack direction='row' spacing={1} sx={{ fontSize: '12px', color: '#00000099' }} alignItems='center'>
                            { props.draft.status === 'review' && 
                            <Typography variant='normal'>In Review</Typography>
                            }
                            { props.draft.status === 'open' && 
                            <Typography variant='normal'>
                                <NumericFormat 
                                    value={props.draft.total_card_carry / 100}
                                    thousandSeparator={true}
                                    displayType={'text'}
                                    prefix={'$'}
                                    decimalScale={0}
                                /> Card Cost
                            </Typography>
                            }
                            { props.draft.status === 'open' &&
                            <AverageCostChip draft={props.draft} />
                            }
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            <Stack direction='row' alignItems='center' spacing={0.5} p={2}>
                { (props.campaignHasOptimizations && props.draft.cost_reduction_opportunity > 0) ? 
                    <Stack justifyContent='center' alignItems='center'>
                        <Typography variant='normal' sx={{ fontSize: '14px' }}>
                            <NumericFormat
                                value={Math.round(props.draft.cost_reduction_opportunity / 100)}
                                thousandSeparator={true}
                                displayType={'text'}
                                prefix={'$'}
                            />
                        </Typography>
                        <Typography variant='normal' sx={{ fontSize: '12px', color: `${theme.palette.subtext.main}`, textAlign: 'center' }}> 
                            Cost Reduction Opportunity /yr
                        </Typography>
                    </Stack>
                    :
                    <Stack py={0.25} px={0.5} justifyContent='center' alignItems='center'>
                        <Typography variant='normal' sx={{ fontSize: '14px' }}>
                            {props.draft.card.yearly_stats?.usage_count ?? 0} Cases
                        </Typography>
                        <Typography variant='normal' sx={{ fontSize: '12px', color: `${theme.palette.subtext.main}` }}>
                            Past 12 Mos.
                        </Typography>
                    </Stack>
                }
                <ChevronRightRounded sx={{ opacity : '0.6', alignSelf: 'end' }}/>
            </Stack>
        </Stack>
    );
}

export default ActiveCardEntry;
